<script setup>
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    title: String,
    href: String,
});

const { t: __ } = useI18n();

const videoId = computed(() => {
    if (!props.href) {
        return;
    }

    let res = props.href.match(/\/video\/(\d+)\/?/);

    return res ? res[1] : null;
});

onMounted(() => {
    if (!document.getElementById("oto-tiktok-script")) {
        let tiktokScript = document.createElement("script");
        tiktokScript.id = "oto-tiktok-script";
        tiktokScript.setAttribute("src", "https://www.tiktok.com/embed.js");
        tiktokScript.setAttribute("async", true);
        document.head.appendChild(tiktokScript);
    }
});
</script>
<template>
    <blockquote v-if="videoId" class="tiktok-embed" :cite="href" :data-video-id="videoId" data-embed-from="oembed" style="max-width: 605px; min-width: 325px">
        <section></section>
    </blockquote>
</template>
